import { RootState } from 'handlers';

export const getPreQualificationData = ({ preQualificationData }: RootState) => preQualificationData;
